<div
  class="h-100 d-flex flex-column"
  *ngIf="!($cardIdInUrl | async)"
>
  <app-title></app-title>

  <div class="flex-grow-1">
    <mat-card class="d-flex flex-row align-items-center gap-2">
      <mat-form-field  appearance="fill" class="w-100">
        <mat-label>{{ "CARD_ID" | translated }}</mat-label>
        <span matTextPrefix *ngIf="insurer" class="font-weight-bold pe-2">
          {{ insurer?.displayedInsurerId }}&nbsp;
        </span>
        <input
          maxlength="12"
          matInput
          #formCardidEl
          type="text"
          pattern="[a-zA-Z0-9]*"
          [formControl]="formCardid"
          (keyup.enter)="onClickOk()"
          [autofocus]
          autocomplete="off"
        />
        <button class="large-icon-button"
          *ngIf="formCardid?.value"
          mat-icon-button
          matSuffix
          type="button"
          aria-label="Clear"
          (click)="clearCardId()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-error *ngIf="formCardid.errors?.minlength || formCardid.errors?.maxlength">
          {{ "CARD_ID_MUST_12_CHAR" | translated }}
        </mat-error>
        <mat-error *ngIf="formCardid.errors?.pattern">
          {{ "CARD_ID_MUST_ALPHANUM" | translated }}
        </mat-error>
        <mat-error *ngIf="formCardid.errors?.invalid">
          {{ "CONTRACT_NOT_KNOWN" | translated }}
        </mat-error>
        <mat-error *ngIf="formCardid.errors?.contractInvalidSubmit">
          {{ "CONTRACT_NOT_KNOWN" | translated }}
        </mat-error>
      </mat-form-field>
    </mat-card>
  </div>

  <div class="row mt-3">
    <div class="col">
      <app-btn
        [dataTxt]="'BACK'"
        (callback)="onClickRetour()"
        [icon]="'chevron-left'"
        [iconLocation]="'left'"
      ></app-btn>
    </div>
    <div class="col text-right">
      <app-btn
        [dataTxt]="'NEXT'"
        [classes]="'btnAnimation'"
        (callback)="onClickOk()"
        [icon]="'chevron-right'"
        [iconLocation]="'right'"
        [disabled]="
          formCardid.errors || formCardid.value.toString().trim() === '' ||
          formCardid.value.toString().trim().length !== 12
        "
      ></app-btn>
    </div>
  </div>
</div>
